export enum CostsUtilityKeys {
  ELECTRICITY_BILL = 'electricity-bill',
  WATER_BILL = 'water-bill',
  GAS_BILL = 'gas-bill',
  INTERNET_BILL = 'internet-bill',
  BROADCASTING = 'broadcasting-bill',
}

export enum CostsUtilityCompatibilityKey {
  UTILITY_BILLS = 'utility-bills',
}

export enum CostsAdditionalKeys {
  ADMINISTRATION_FEE = 'administration-fee',
  CLEANING_FEE = 'cleaning-fee',
  OTHER_ADDITIONAL_COSTS = 'other-additional-costs',
}

export enum CostsDepositKeys {
  SECURITY_DEPOSIT = 'security-deposit',
  BEDDING_DEPOSIT = 'bedding-deposit',
  TOWEL_DEPOSIT = 'towel-deposit',
  OTHER_DEPOSIT = 'other-deposit',
}

export enum CostsOptionalKeys {
  BIKE_RENT = 'bike-rent',
  CLEANING_SERVICE = 'cleaning-service',
  EARLY_MOVE_IN = 'early-move-in',
  EARLY_MOVE_OUT = 'early-move-out',
  FINAL_CLEANING = 'final-cleaning',
  FULL_BOARD = 'full-board',
  GYM = 'gym',
  HALF_BOARD = 'half-board',
  LATE_MOVE_IN = 'late-move-in',
  LATE_MOVE_OUT = 'late-move-out',
  OVERNIGHT_GUESTS = 'overnight-guests',
  OTHER_OPTIONAL_COSTS = 'other-optional-costs',
  PARKING = 'parking',
  TOWEL_BEDDING = 'towels-and-bedding',
  END_EARLY = 'end-early-fee',
}
